import React from 'react'
import { Link } from 'react-router-dom'
import Icon1 from '../../assets/img/logo/favicon.png';
import image1 from '../../assets/img/find.jpeg'
import line from '../../assets/img/line.png'
import image2 from '../../assets/img/image1.jpeg'
import GetStartedButton from '../../components/CTA/GetStartedButton';


function HowItWorks() {
  const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
  const createAcount  = [
      {
        id:1,
        icon:1,
        title: 'Create Your Account',
        description: 'Sign up for a free Cardplot account with your email or phone number. Verify your details, and you’re ready to start your journey to seamless financial management.'
      },
      {
        id:2,
        icon:2,
        title: 'Access Our Features',
        description: 'From virtual multi-currency wallet to secure virtual cards, bill payments and currency exchange, explore our suite of tools designed to simplify your transactions. Whether are managing personal finances or running a business,  Cardplot has you covered.'
      },
      {
        id:3,
        icon:3,
        title: 'Transact with Ease',
        description: 'Send money,pay bills, or purchase airtimes--fast, secure, and hassle-free. Need to Manage cross-border transactions? Cardplot ensures your funds reach their destination without any delays or hidden fees.',
      }

  ]
  return (
    <>
      <section className='breadcrumb__section bg-overlay'>
        <div className="container">
          <div className='row'>
            <div className='col-md-12'>
              <div className="breadcrumb__title__head">
                <ol className="breadcrumb">
                  <li className="active"><img src={Icon1} style={{ width: '25px', height: '25px' }} alt="" /></li>
                </ol>
                <h2 className='breadcrumb__title'> HOW IT WORKS </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb__text">
                <h3 className='breadcrumb__text__head heading'> With Cardplot, managing your finances is seamless and intuitive.</h3>
                <p className='breadcrumb__text__content'>Here’s how you can take charge of your finances with just a few clicks:</p>
              </div>
              <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                  Get Started
                </a>
                <Link to='/contact' className='btn btn__outline_primary text__dark'>Contact us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='find_your_account'>
        <div className='container'>
          <div className='row w-half justify-content-center align-items-center'>
            <div className='col-12 col-md-6 mb-4 mb-lg-0'>
              <div className='find_your_account__image'>
                <img src={image1} className='img-fluid' alt='find your account' />
              </div>
            </div>
            <div className='col-12 col-md-6 mb-4 mb-lg-0'>
              <div className='text-center'>
                <h2 className='find_your_account__title'>You can send Nigerian Naira..</h2>
                <p className='find_your_account__subtitle'>Fund your account with naira. Choose the transfers tab and choose your destination country, the enter the amount you want the recipient to get in Ghanian Cedis .</p>
              </div>
            </div>
          </div>
          <div className="row w-half justify-content-center align-items-center">
            <div className="col-12">
              <img src={line} className='img-fluid position-relative line__inner' width={550} />
            </div>
          </div>
          <div className="row w-half justify-content-center align-items-center">
            <div className='col-12 col-md-6 mb-4 mb-lg-0'>
              <div className='text-center'>
                <h2 className='find_your_account__title'>... and they receive Ghanian Cedi</h2>
                <p className='find_your_account__subtitle'>In a flash, we’ll convert your Nigerian Naira to Ghana Cedi and show you the total cost before you initiate the transaction.</p>
              </div>
            </div>
            <div className='col-12 col-md-6 mb-4 mb-lg-0'>
              <div className='find_your_account__image'>
                <img src={image2} className='img-fluid' alt='find your account' />
              </div>
            </div>
          </div>
        </div>

        <div className='container'>
          <div className='create__account__container'>
            {createAcount.map((item, index) => (
              <div key={index} className='create__account__box'>
                <div className='create__account__icon'>
                  {item.icon}
                </div>
                <div className='create__account__content'>
                  <h2 className='create__account__title'>{item.title}</h2>
                  <p className='create__account__subtitle'>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <GetStartedButton />
    </>
  )
}

export default HowItWorks